/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ReprocessGradePersonOnlyViewModel } from "../types/ReprocessGradePersonOnlyViewModel.ts";

export const reprocessGradePersonOnlyViewModelSchema = z.object({
  classroomDisciplineId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da disciplina na sala de aula para a qual a nota deve ser reprocessada. Obrigatório.",
      ),
  ),
  personId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da pessoa (aluno) cuja nota deve ser reprocessada. Obrigatório.",
      ),
  ),
}) as unknown as ToZod<ReprocessGradePersonOnlyViewModel>;
